import { useState, useEffect } from 'react';
import api from '../api/axios';
import { useAuth } from '../contexts/AuthContext';

export default function ContactAttributes() {
  const { selectedBusiness } = useAuth();
  const bid = selectedBusiness?.id;
  const [attributes, setAttributes] = useState([]);
  const [name, setName] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (bid) loadAttributes(); }, [bid]);

  const loadAttributes = async () => {
    try {
      const r = await api.get(`/contacts/attributes?business_id=${bid}`);
      setAttributes(Array.isArray(r.data) ? r.data : []);
    } catch { setAttributes([]); }
  };

  const addAttribute = async () => {
    if (!name.trim()) { setMsg('Attribute name required'); return; }
    setLoading(true);
    try {
      await api.post('/contacts/attributes', { name: name.trim(), business_id: bid });
      setName('');
      setMsg('✅ Attribute added!');
      loadAttributes();
      setTimeout(() => setMsg(''), 2000);
    } catch (e) { setMsg('❌ ' + (e.response?.data?.error || 'Failed')); }
    setLoading(false);
  };

  const deleteAttribute = async (id) => {
    if (!window.confirm('Delete this attribute?')) return;
    try {
      await api.delete(`/contacts/attributes/${id}?business_id=${bid}`);
      loadAttributes();
    } catch {}
  };

  const inp = { width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 14, boxSizing: 'border-box', outline: 'none', fontFamily: 'inherit' };

  return (
    <div style={{ padding: '28px 32px', fontFamily: 'DM Sans, sans-serif', background: '#f4f6f9', minHeight: '100vh' }}>
      <h2 style={{ fontSize: 22, fontWeight: 800, color: '#111', margin: '0 0 20px' }}>Contact Attributes</h2>

      <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #e5e7eb', overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
        <div style={{ padding: '14px 24px', background: '#f9fafb', borderBottom: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 16 }}>🔄</span>
          <span style={{ fontSize: 14, fontWeight: 700, color: '#15803d' }}>Contact Attributes</span>
        </div>

        <div style={{ display: 'flex', gap: 32, padding: 28 }}>
          {/* Add Form */}
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#111', marginBottom: 20 }}>Add Contact Attributes</div>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6, display: 'block' }}>Attribute Name</label>
            <input style={{ ...inp, marginBottom: 16 }} placeholder="Enter Attribute Name" value={name} onChange={e => setName(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && addAttribute()} />
            {msg && <div style={{ marginBottom: 12, fontSize: 13, color: msg.includes('✅') ? '#16a34a' : '#ef4444', fontWeight: 600 }}>{msg}</div>}
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setName('')} style={{ padding: '10px 22px', borderRadius: 8, border: '1px solid #e5e7eb', background: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 600, color: '#374151' }}>Cancel</button>
              <button onClick={addAttribute} disabled={loading} style={{ padding: '10px 22px', borderRadius: 8, border: 'none', background: '#16a34a', color: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 700 }}>Submit</button>
            </div>
          </div>

          {/* Attributes List */}
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#111', marginBottom: 20 }}>Contact Attributes List</div>
            {attributes.length === 0 ? (
              <p style={{ color: '#9ca3af', fontSize: 14 }}>No attributes yet. Add your first attribute!</p>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {attributes.map((attr, i) => (
                  <div key={attr.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 16px', background: '#f9fafb', borderRadius: 8, border: '1px solid #e5e7eb' }}>
                    <span style={{ fontSize: 14, fontWeight: 600, color: '#374151' }}>{i + 1}) {attr.name}</span>
                    <button onClick={() => deleteAttribute(attr.id)} style={{ background: '#fee2e2', color: '#dc2626', border: 'none', borderRadius: 6, padding: '5px 12px', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>
                      Delete 🗑
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
